<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
        <div data-cy="tool-id-create_shipping_order" *ngIf="!toolbar.create_shipping_order.hidden" class="toolContainer">
        <button mat-button
                data-cy="button"
                class="datex-button"
                [disabled]="toolbar.create_shipping_order.control.readOnly"
                [ngStyle]="toolbar.create_shipping_order.control.styles.style"
                [ngClass]="toolbar.create_shipping_order.control.styles.classes"
                (click)="on_create_shipping_order_clicked($event)"
                >
          <div class="button-label">
            <ng-container *ngIf="toolbar.create_shipping_order.control.icon === 'datex-default-spinner'; else showIcon">
              <div class="button-icon">
                <i data-cy="button-icon" class="datex-default-spinner"></i>
              </div>
            </ng-container>
            <ng-template #showIcon>
              <div class="button-icon">
                <i data-cy="button-icon" class="icon {{toolbar.create_shipping_order.control.icon}}"></i>
              </div>
            </ng-template>
            <div data-cy="button-label" class="button-text">{{toolbar.create_shipping_order.control.label}}</div>
          </div>
        
        </button>
        </div>
        <div data-cy="tool-id-import_orders" *ngIf="!toolbar.import_orders.hidden" class="toolContainer">
        <button mat-button
                data-cy="button"
                class="datex-button"
                [disabled]="toolbar.import_orders.control.readOnly"
                [ngStyle]="toolbar.import_orders.control.styles.style"
                [ngClass]="toolbar.import_orders.control.styles.classes"
                (click)="on_import_orders_clicked($event)"
                >
          <div class="button-label">
            <ng-container *ngIf="toolbar.import_orders.control.icon === 'datex-default-spinner'; else showIcon">
              <div class="button-icon">
                <i data-cy="button-icon" class="datex-default-spinner"></i>
              </div>
            </ng-container>
            <ng-template #showIcon>
              <div class="button-icon">
                <i data-cy="button-icon" class="icon {{toolbar.import_orders.control.icon}}"></i>
              </div>
            </ng-template>
            <div data-cy="button-label" class="button-text">{{toolbar.import_orders.control.label}}</div>
          </div>
        
        </button>
        </div>
        <div data-cy="tool-id-manage_ship_to_contacts" *ngIf="!toolbar.manage_ship_to_contacts.hidden" class="toolContainer">
        <button mat-button
                data-cy="button"
                class="datex-button"
                [disabled]="toolbar.manage_ship_to_contacts.control.readOnly"
                [ngStyle]="toolbar.manage_ship_to_contacts.control.styles.style"
                [ngClass]="toolbar.manage_ship_to_contacts.control.styles.classes"
                (click)="on_manage_ship_to_contacts($event)"
                >
          <div class="button-label">
            <ng-container *ngIf="toolbar.manage_ship_to_contacts.control.icon === 'datex-default-spinner'; else showIcon">
              <div class="button-icon">
                <i data-cy="button-icon" class="datex-default-spinner"></i>
              </div>
            </ng-container>
            <ng-template #showIcon>
              <div class="button-icon">
                <i data-cy="button-icon" class="icon {{toolbar.manage_ship_to_contacts.control.icon}}"></i>
              </div>
            </ng-template>
            <div data-cy="button-label" class="button-text">{{toolbar.manage_ship_to_contacts.control.label}}</div>
          </div>
        
        </button>
        </div>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!filtersets.newGroup1.hidden"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.newGroup1.collapsible }">
                    <div *ngIf="!filtersets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">Filters</span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.newGroup1.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-owner" *ngIf="!filters.owner.hidden" 
                                  class="field-container standard {{filters.owner.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.owner.styles.style"
                                  [ngClass]="filters.owner.styles.classes">
                              <div class="label-container"
                                    title="{{filters.owner.label}}{{filters.owner.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.owner.label}}">{{filters.owner.label}}<span *ngIf="filters.owner.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <Owners-owners_dd_single 
                                  data-cy="selector"
                                  [type]="filters.owner.control.type"
                                  formControlName="owner"
                                  (displayTextChange)="filters.owner.control.displayText=$event"
                                  [placeholder]="filters.owner.control.placeholder"
                                  [styles]="filters.owner.control.styles"
                                [statusId]="$fields_owner_selector_inParams_statusId"
                                [projectId]="$fields_owner_selector_inParams_projectId"
                              >
                              </Owners-owners_dd_single>
                              <ng-container *ngIf="filters.owner.invalid">
                                <ng-container *ngFor="let error of filters.owner.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-project" *ngIf="!filters.project.hidden" 
                                  class="field-container standard {{filters.project.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.project.styles.style"
                                  [ngClass]="filters.project.styles.classes">
                              <div class="label-container"
                                    title="{{filters.project.label}}{{filters.project.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.project.label}}">{{filters.project.label}}<span *ngIf="filters.project.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <Owners-projects_dd_single 
                                  data-cy="selector"
                                  [type]="filters.project.control.type"
                                  formControlName="project"
                                  (displayTextChange)="filters.project.control.displayText=$event"
                                  [placeholder]="filters.project.control.placeholder"
                                  [styles]="filters.project.control.styles"
                                [statusId]="$fields_project_selector_inParams_statusId"
                                [ownerId]="$fields_project_selector_inParams_ownerId"
                              >
                              </Owners-projects_dd_single>
                              <ng-container *ngIf="filters.project.invalid">
                                <ng-container *ngFor="let error of filters.project.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-warehouse" *ngIf="!filters.warehouse.hidden" 
                                  class="field-container standard {{filters.warehouse.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.warehouse.styles.style"
                                  [ngClass]="filters.warehouse.styles.classes">
                              <div class="label-container"
                                    title="{{filters.warehouse.label}}{{filters.warehouse.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.warehouse.label}}">{{filters.warehouse.label}}<span *ngIf="filters.warehouse.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <Locations-warehouses_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.warehouse.control.type"
                                  formControlName="warehouse"
                                  (displayTextChange)="filters.warehouse.control.displayText=$event"
                                  [placeholder]="filters.warehouse.control.placeholder"
                                  [styles]="filters.warehouse.control.styles"
                              >
                              </Locations-warehouses_dd_multi>
                              <ng-container *ngIf="filters.warehouse.invalid">
                                <ng-container *ngFor="let error of filters.warehouse.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-status" *ngIf="!filters.status.hidden" 
                                  class="field-container standard {{filters.status.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.status.styles.style"
                                  [ngClass]="filters.status.styles.classes">
                              <div class="label-container"
                                    title="{{filters.status.label}}{{filters.status.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.status.label}}">{{filters.status.label}}<span *ngIf="filters.status.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <PurchaseOrders-orderstatuses_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.status.control.type"
                                  formControlName="status"
                                  (displayTextChange)="filters.status.control.displayText=$event"
                                  [placeholder]="filters.status.control.placeholder"
                                  [styles]="filters.status.control.styles"
                                [statusIds]="$fields_status_selector_inParams_statusIds"
                              >
                              </PurchaseOrders-orderstatuses_dd_multi>
                              <ng-container *ngIf="filters.status.invalid">
                                <ng-container *ngFor="let error of filters.status.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-materials" *ngIf="!filters.materials.hidden" 
                                  class="field-container standard {{filters.materials.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.materials.styles.style"
                                  [ngClass]="filters.materials.styles.classes">
                              <div class="label-container"
                                    title="{{filters.materials.label}}{{filters.materials.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.materials.label}}">{{filters.materials.label}}<span *ngIf="filters.materials.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <Materials-materials_by_project_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.materials.control.type"
                                  formControlName="materials"
                                  (displayTextChange)="filters.materials.control.displayText=$event"
                                  [placeholder]="filters.materials.control.placeholder"
                                  [styles]="filters.materials.control.styles"
                                [projectId]="$fields_materials_selector_inParams_projectId"
                              >
                              </Materials-materials_by_project_dd_multi>
                              <ng-container *ngIf="filters.materials.invalid">
                                <ng-container *ngFor="let error of filters.materials.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-reference" *ngIf="!filters.reference.hidden" 
                                  class="field-container standard {{filters.reference.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.reference.styles.style"
                                  [ngClass]="filters.reference.styles.classes">
                              <div class="label-container"
                                    title="{{filters.reference.label}}{{filters.reference.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.reference.label}}">{{filters.reference.label}}<span *ngIf="filters.reference.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <input data-cy="textBox"formControlName="reference"
                                      matInput
                                      autocomplete="off"
                                      spellcheck="false"
                                      class="datex-textbox {{filters.reference.control.readOnly ? 'readonly ' : ''}}"
                                      placeholder="{{filters.reference.control.placeholder}}"
                                      [ngStyle]="filters.reference.control.styles.style"
                                      [ngClass]="filters.reference.control.styles.classes"> 
                              <ng-container *ngIf="filters.reference.invalid">
                                <ng-container *ngFor="let error of filters.reference.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-date_from" *ngIf="!filters.date_from.hidden" 
                                  class="field-container standard {{filters.date_from.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.date_from.styles.style"
                                  [ngClass]="filters.date_from.styles.classes">
                              <div class="label-container"
                                    title="{{filters.date_from.label}}{{filters.date_from.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.date_from.label}}">{{filters.date_from.label}}<span *ngIf="filters.date_from.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <app-datebox 
                                  data-cy="dateBox"
                                  formControlName="date_from"
                                  [format]="filters.date_from.control.format"
                                  [mode]="filters.date_from.control.mode"
                                  [ngStyle]="filters.date_from.control.styles.style"
                                  [ngClass]="filters.date_from.control.styles.classes">
                              </app-datebox>
                              <ng-container *ngIf="filters.date_from.invalid">
                                <ng-container *ngFor="let error of filters.date_from.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-date_to" *ngIf="!filters.date_to.hidden" 
                                  class="field-container standard {{filters.date_to.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.date_to.styles.style"
                                  [ngClass]="filters.date_to.styles.classes">
                              <div class="label-container"
                                    title="{{filters.date_to.label}}{{filters.date_to.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.date_to.label}}">{{filters.date_to.label}}<span *ngIf="filters.date_to.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <app-datebox 
                                  data-cy="dateBox"
                                  formControlName="date_to"
                                  [format]="filters.date_to.control.format"
                                  [mode]="filters.date_to.control.mode"
                                  [ngStyle]="filters.date_to.control.styles.style"
                                  [ngClass]="filters.date_to.control.styles.classes">
                              </app-datebox>
                              <ng-container *ngIf="filters.date_to.invalid">
                                <ng-container *ngFor="let error of filters.date_to.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-ship_to_search" *ngIf="!filters.ship_to_search.hidden" 
                                  class="field-container double {{filters.ship_to_search.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.ship_to_search.styles.style"
                                  [ngClass]="filters.ship_to_search.styles.classes">
                              <div class="label-container"
                                    title="{{filters.ship_to_search.label}}{{filters.ship_to_search.required ? ' (required)' : ''}}">
                                <label data-cy="field-label" class="datex-label"
                                        title="{{filters.ship_to_search.label}}">{{filters.ship_to_search.label}}<span *ngIf="filters.ship_to_search.required"
                                        class="required-asterisk">*</span></label>
                              </div>
                              <input data-cy="textBox"formControlName="ship_to_search"
                                      matInput
                                      autocomplete="off"
                                      spellcheck="false"
                                      class="datex-textbox {{filters.ship_to_search.control.readOnly ? 'readonly ' : ''}}"
                                      placeholder="{{filters.ship_to_search.control.placeholder}}"
                                      [ngStyle]="filters.ship_to_search.control.styles.style"
                                      [ngClass]="filters.ship_to_search.control.styles.classes"> 
                              <ng-container *ngIf="filters.ship_to_search.invalid">
                                <ng-container *ngFor="let error of filters.ship_to_search.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
                        </div>
                      </div>
                    </div>            </div>
          </div>
        </div>

        <div class="widgets">
          <div *ngIf="!widgets.order_total_picked_order_count_by_date_widget.hidden" class="widget-container">
            <SalesOrders-order_total_picked_order_count_by_date_widget
            #$widgets_order_total_picked_order_count_by_date_widget 
              [date]="$widgets_order_total_picked_order_count_by_date_widget_inParams_date"
              [ownerId]="$widgets_order_total_picked_order_count_by_date_widget_inParams_ownerId"
              [projectId]="$widgets_order_total_picked_order_count_by_date_widget_inParams_projectId"
              [warehouseId]="$widgets_order_total_picked_order_count_by_date_widget_inParams_warehouseId"
            ($refreshEvent)="refresh(false, false, '$widgets_order_total_picked_order_count_by_date_widget')"
            >
            </SalesOrders-order_total_picked_order_count_by_date_widget>
          </div>
          <div *ngIf="!widgets.order_total_completed_order_count_by_date_wdiget.hidden" class="widget-container">
            <SalesOrders-order_total_completed_order_count_by_date_widget
            #$widgets_order_total_completed_order_count_by_date_wdiget 
              [date]="$widgets_order_total_completed_order_count_by_date_wdiget_inParams_date"
              [ownerId]="$widgets_order_total_completed_order_count_by_date_wdiget_inParams_ownerId"
              [projectId]="$widgets_order_total_completed_order_count_by_date_wdiget_inParams_projectId"
              [warehouseId]="$widgets_order_total_completed_order_count_by_date_wdiget_inParams_warehouseId"
            ($refreshEvent)="refresh(false, false, '$widgets_order_total_completed_order_count_by_date_wdiget')"
            >
            </SalesOrders-order_total_completed_order_count_by_date_widget>
          </div>
        </div>

        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="!tabs.shipping_orders.hidden" class="tab" data-cy="tab-shipping_orders">
              <h2 [className]="tabs.shipping_orders.active? 'active': ''" (click)="tabs.shipping_orders.activate()">{{tabs.shipping_orders.title}}</h2>
            </div>
          </div>
        
              <ng-container
                *ngIf="tabs.shipping_orders.active">
                  <mat-select (selectionChange)="onTabSelected($event)"
                              *ngIf="subTabGroups.shipping_orders.tabs.length > 1"
                              class="datex-queryselector"
                              [value]="subTabGroups.shipping_orders.activeTab"
                              disableOptionCentering
                              panelClass="dropdown-below datex-dropdownpanel">
                    <mat-option [value]="tab" *ngFor="let tab of subTabGroups.shipping_orders.tabs">{{tab.title}}</mat-option>
                  </mat-select>
                
                  <FootPrintPortalManager-shipping_orders_grid
                   *ngIf="tabs.shipping_orders.tabs.shipping_orders.active"
                  #$tabs_shipping_orders_shipping_orders
                  [projectId]="$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_projectId"
                  [warehouseId]="$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_warehouseId"
                  [statusIds]="$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_statusIds"
                  [reference]="$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_reference"
                  [materialIds]="$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_materialIds"
                  [fromDate]="$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_fromDate"
                  [toDate]="$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_toDate"
                  [ownerId]="$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_ownerId"
                  [ship_to_search]="$tabs_shipping_orders_shipping_orders_shipping_orders_grid_inParams_ship_to_search"
                  ($refreshEvent)="refresh(false, false, '$tabs_shipping_orders_shipping_orders')">
                  </FootPrintPortalManager-shipping_orders_grid>
                  <FootPrintPortalManager-shipping_orders_by_tracking_grid
                   *ngIf="tabs.shipping_orders.tabs.shipping_orders_tracking.active"
                  #$tabs_shipping_orders_shipping_orders_tracking
                  [ownerId]="$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_ownerId"
                  [projectId]="$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_projectId"
                  [warehouseId]="$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_warehouseId"
                  [statusIds]="$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_statusIds"
                  [reference]="$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_reference"
                  [materialIds]="$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_materialIds"
                  [fromDate]="$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_fromDate"
                  [toDate]="$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_toDate"
                  [ship_to_search]="$tabs_shipping_orders_shipping_orders_tracking_shipping_orders_by_tracking_grid_inParams_ship_to_search"
                  ($refreshEvent)="refresh(false, false, '$tabs_shipping_orders_shipping_orders_tracking')">
                  </FootPrintPortalManager-shipping_orders_by_tracking_grid>
              </ng-container>
        </div>

      </ng-container>
    </div>
  </div>
</div>